import { render, staticRenderFns } from "./OverlayButton.vue?vue&type=template&id=7f0c7d4d&"
import script from "./OverlayButton.vue?vue&type=script&lang=ts&"
export * from "./OverlayButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports